
import { useState, useEffect, useRef } from 'react';

export const useGoogleCharts = () => {
  const googleChartsLoaded = useRef<boolean>(false);

  useEffect(() => {
    const loadGoogleCharts = () => {
      const script = document.createElement('script');
      script.src = 'https://www.gstatic.com/charts/loader.js';
      script.async = true;
      script.onload = () => {
        window.google.charts.load('current', {
          'packages': ['corechart']
        });
        window.google.charts.setOnLoadCallback(() => {
          googleChartsLoaded.current = true;
        });
      };
      document.head.appendChild(script);
    };
    loadGoogleCharts();
  }, []);

  return { googleChartsLoaded: googleChartsLoaded.current };
};
